import type { AdminNatCodesCode } from '#api/tmsApiService'
export type StatusFilter = 'all' | 'draft' | 'published' | 'draft_formerly_published'

export function buildCodeStatusFilter(status: StatusFilter) {
  return (code: AdminNatCodesCode) => {
    switch (status) {
      case 'all':
        return true
      case 'draft_formerly_published':
        return code.status === 'draft_formerly_published'
      case 'draft':
        return code.status === 'draft'
      case 'published':
        return code.status === 'published'
      default:
        return false
    }
  }
}
